import { getEntitlementBlockCatalogEntry } from 'pi-kiosk-shared/tenant-entitlements';
import type { EnterpriseNavItem } from '../../dashboard/components/EnterpriseGroupedNav/enterpriseNavGroups.js';
import { resolveSectionCapabilityRequirement } from './sectionCapabilityMap.js';

export interface NavCapabilityRequirement {
  readonly capability?: string;
  readonly anyOf?: readonly string[];
  readonly allOf?: readonly string[];
}

/** Route-only nav items (no DashboardSection) — extend section map, do not duplicate. */
const NAV_ROUTE_CAPABILITY_OVERRIDES: Readonly<Record<string, NavCapabilityRequirement>> = {
  'success-incident-centre': { capability: 'admin:outbox:read' },
};

export function resolveNavCapabilityRequirement(item: EnterpriseNavItem): NavCapabilityRequirement {
  if (item.section !== undefined) {
    const fromSection = resolveSectionCapabilityRequirement(item.section);
    if (
      fromSection.capability !== undefined ||
      (fromSection.anyOf !== undefined && fromSection.anyOf.length > 0) ||
      (fromSection.allOf !== undefined && fromSection.allOf.length > 0)
    ) {
      return {
        ...(fromSection.capability !== undefined ? { capability: fromSection.capability } : {}),
        ...(fromSection.anyOf !== undefined ? { anyOf: fromSection.anyOf } : {}),
        ...(fromSection.allOf !== undefined ? { allOf: fromSection.allOf } : {}),
      };
    }
  }

  const routeOverride = NAV_ROUTE_CAPABILITY_OVERRIDES[item.id];
  if (routeOverride !== undefined) {
    return routeOverride;
  }

  if (item.entitlementBlockKey !== undefined) {
    const entry = getEntitlementBlockCatalogEntry(item.entitlementBlockKey);
    if (entry?.capabilityHint !== undefined && !entry.capabilityHint.includes('*')) {
      return { capability: entry.capabilityHint };
    }
  }

  return {};
}
